import { useRef, useEffect, forwardRef, useImperativeHandle } from 'react'
import classNames from 'classnames'
import { createUseStyles } from 'react-jss'
import PropTypes from 'prop-types'
import style from './style'

const useStyles = createUseStyles(style)

const Input = forwardRef(({
  defaultGeolocationAddress,
  googlemaps,
  isLoading,
  onSubmit,
  placeholder,
}, ref) => {
  const classes = useStyles()
  const $input = useRef(null)
  const autocomplete = useRef(null)

  useImperativeHandle(ref, () => ({
    ref: $input.current,
  }))

  useEffect(() => {
    // Transform the <input /> in Google Automplete
    if (googlemaps && $input.current) {
      autocomplete.current = new googlemaps.places.Autocomplete($input.current, { types: ['geocode'] })
    }
  }, [googlemaps])

  const handleSubmit = (e) => {
    e.preventDefault()
    onSubmit()
  }

  useEffect(() => {
    if (defaultGeolocationAddress.length > 0) $input.current.value = defaultGeolocationAddress
  }, [defaultGeolocationAddress])

  return (
    <form
      className={`${classes.form} Autocomplete__form`}
      onSubmit={handleSubmit}
      ref={ref}
    >
      <input
        className={classNames({
          [classes.input]: true,
          Autocomplete__input: true,
          [classes.inputDisabled]: isLoading,
        })}
        type="text"
        ref={$input}
        placeholder={placeholder}
        spellCheck="false"
      />
      <div className={classes.spinner}>
        <svg
          viewBox="0 0 50 50"
          className={classNames({
            [classes.spinnerLoader]: true,
            [classes.hide]: !isLoading,
          })}
        >
          <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="1" />
        </svg>
      </div>
    </form>
  )
})

Input.defaultProps = {
  defaultGeolocationAddress: '',
}

Input.propTypes = {
  defaultGeolocationAddress: PropTypes.string,
}

export default Input
